module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "i-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "loginBtn"
  }, [_c('el-menu', {
    staticClass: "docMenu",
    attrs: {
      "mode": "horizontal"
    }
  }, [_c('el-submenu', {
    attrs: {
      "index": "1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("index.documentation")))])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "../../static/apidoc/docs.html",
      "target": "_blank"
    }
  }, [_vm._v("API")])]), _vm._v(" "), _c('el-submenu', {
    staticClass: "subMenu",
    attrs: {
      "index": "1-2"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("SDK")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-2-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/wanchain/iWan-js-sdk",
      "target": "_blank"
    }
  }, [_vm._v("JavaScript")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-2-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/wanchain/iWan-java-sdk",
      "target": "_blank"
    }
  }, [_vm._v("Java")])])], 2)], 2)], 1), _vm._v(" "), _c('router-link', {
    staticClass: "login",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v(_vm._s(_vm.$t("index.login")))]), _vm._v(" "), _c('router-link', {
    staticClass: "goRe",
    attrs: {
      "to": "/register"
    }
  }, [_vm._v(_vm._s(_vm.$t("index.signup")))])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/logo.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-876916d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header/Header.vue
// module id = 989
// module chunks = 1